import { useCallback } from 'react';
import { useNavigate } from 'react-router';

export const useGlobalSearchPageNavigation = () => {
  const navigate = useNavigate();

  return useCallback(
    async (path: string) => {
      await navigate(path);
    },
    [navigate],
  );
};
